import YFormAvatar from './Avatar';

export { YFormAvatar };
export default YFormAvatar;
